<template>
  <div>
    <template v-if="plot.ChildrenPlots.length == 0">
      <PlotHeaderEntry :plot="plot" pad />
    </template>
    <template v-else>
      <v-list-group value="false">
        <template v-slot:activator>
          <PlotHeaderEntry :plot="plot" />
        </template>
        <PlotHeaderEntry v-for="childPlot in plot.ChildrenPlots" :key="childPlot.Id" :plot="childPlot" :pad="childPlot.ChildrenPlots.length == 0" />
      </v-list-group>
    </template>

  </div>
</template>

<script>
  import PlotHeaderEntry from '@/components/VegetativeMonitoring/Header/PlotHeaderEntry'
  export default {
    components: {
      PlotHeaderEntry,
    },
    props: {
      plot: {
        type: Object,
        required: true,
      },
    },
  }
</script>